function preloader() {
    setTimeout(function() {
        $('html, body').css('overflow-y', 'visible');
        $('.async-preloader').css('opacity', '0');
        setTimeout(function() {
            $('.async-preloader').hide();
        }, 300);
    }, 800);
}

$(document).ready(function() {

    preloader();

});
